export default __webpack_public_path__ + "static/media/next.8c08d54a.svg";